/**
 * This file is used for styling the forms created by Shopify Forms.
 * Some styles all have the !important tag, since not including it does not apply the style.
 */

window.formStyles = window.formStyles || new Map();
window.formStyles.set("my-custom-rules", `
:root {
    --btn-bg-color: 200 212 0;
    --btn-bg-hover-color: 185 196 0;
    --btn-text-color: 9 3 2;
}
* {
    font-family: 'Gabarito', sans-serif !important;
}
h2, form, p {
    padding: 0 1rem !important;
}
button[type="submit"] {
    border: 2px solid rgb(var(--btn-bg-color)) !important;
    border-radius: 7px !important;
    outline-offset: 3px !important;
    outline-color: rgb(var(--btn-bg-color)) !important;
    font-weight: 700 !important;
    transition: opacity 0.6s ease, color 0.6s ease, background-position 0.4s ease-out !important;
    font-size: 0.88em !important;
    background: rgb(var(--btn-bg-hover-color)) linear-gradient(104deg, rgb(var(--btn-bg-hover-color)) 60%, rgb(var(--btn-bg-color)) 60% 100%) no-repeat 100% 100% !important;
    background-size: 260% 100% !important;
    color: rgb(var(--btn-text-color)) !important;
    background-position: 100% 100% !important;
}
button[type="submit"]:hover {
    border: 2px solid rgb(var(--btn-bg-color)) !important;
    filter: none !important;
    background-color: rgb(var(--btn-bg-hover-color)) !important;
    color: rgb(var(--btn-text-color)) !important;
    background-position: 0 100% !important;
}
@media (max-width: 600px) {
    #app-embed > div:first-of-type {
        display: block !important;
        padding: var(--gutter) !important;
        width: calc(100 % - (2 * var(--gutter))) !important;
    }
}
`);